import gql from 'graphql-tag';

export const EditorPreferencesQuery = gql`
	query EditorPreferencesQuery {
		userPreferences {
			confluenceEditorSettings {
				toolbarDockingInitialPosition
			}
		}
	}
`;
